import Access from 'ui/Access';
import Users from '../users/Users';

export const TAB_LIST = [
    {
        name: 'users',
        label: 'Users',
        access: Access.SUBSCRIPTION_USERS,
        component: Users,
    },
    {
        name: 'groups',
        label: 'Groups',
        access: Access.SUBSCRIPTION_GROUPS,
        disabled: true,
    },
    {
        name: 'devices',
        label: 'Devices',
        access: Access.SUBSCRIPTION_DEVICES,
        disabled: true,
    },
    {
        name: 'policies',
        label: 'Policies',
        access: Access.SUBSCRIPTION_POLICIES,
        disabled: true,
    },
    {
        name: 'connectors',
        label: 'Connectors',
        access: Access.SUBSCRIPTION_CONNECTORS,
        disabled: true,
    },
    {
        name: 'backups',
        label: 'Backups',
        access: Access.SUBSCRIPTION_BACKUPS,
        disabled: true,
    },
    {
        name: 'settings',
        label: 'Settings',
        access: Access.SUBSCRIPTION_SETTINGS,
        disabled: true,
    },
];

export const TAB_FORM_LIST = [
    {
        name: 'users',
        label: 'User Info',
    },
];

export const SUBSCRIPTION_MESSAGES = {
    Create: 'User(s) will be created.',
    Update: 'User(s) will be updated.',
    Delete: 'User(s) will be deleted.',
    Disable: 'User(s) will be disabled.',
    Enable: 'User(s) will be enabled.',
    Convert: 'User(s) will be converted to personal.',
    ChangePassword: 'User(s) will be forced to change their password.',
    ResetPassword: 'User(s) will have their password reset.',
    Migrate: `The following user(s) already have personal CyberFOX Password Manager accounts.
            We have sent an email to the user(s) confirming that they want to
            convert their personal account to your business account.
            After the user accepts the transfer their account will appear on the Users tab of the portal.`,
    Unknown: 'An unexpected error occurred',
    DeleteFail: 'Unable to delete user(s).',
};
